import { createStore } from 'vuex'
import { login } from '@/api/index'
import { userList } from '@/api/system'
import { message } from 'ant-design-vue'
import { isPermission } from '@/utils/permission'
import { storage, sessionStorage } from '@/utils/storage'

export default createStore({
  state: {
    user: {
      token: '',
      menus: [],
      roles: [],
      index_page: ''
    },
    loading: 0, // 页面级loading
    loanOptions: [],
    loanOptionsGroup: <any>[],
    regionOptions: {
      NA: [],
      EU: []
    },
    bdOptions: [],
    allBdOptions: [],
    bdOptionsLoading: false,
    bdOptionsLoaded: false,
    usefulLoanOptionsGroup: [
      {
        "label": "自营产品",
        "value": "self",
        "children": [
          {
            "value": "15",
            "label": "亚马逊优享贷（中关村）",
            "ownership_type": "self",
            "disabled": null
          },
          {
            "value": "22",
            "label": "亚马逊速享贷（中关村）",
            "ownership_type": "self",
            "disabled": null
          },
          {
            "value": "12",
            "label": "亚马逊增享贷（陆安）",
            "ownership_type": "self",
            "disabled": null
          },
          {
            "value": "32",
            "label": "微众跨境贷",
            "ownership_type": "self",
            "disabled": null
          },
          {
            "value": "28",
            "label": "亚马逊宜享贷（富融）",
            "ownership_type": "self",
            "disabled": null
          },
          {
            "value": "27",
            "label": "亚马逊随享贷（天图）",
            "ownership_type": "self",
            "disabled": null
          }
        ]
      },
      {
        "label": "合作产品",
        "value": "cooperate",
        "children": [
          {
            "value": "33",
            "label": "微众自营贷",
            "ownership_type": "cooperate",
            "disabled": null
          },
          {
            "value": "16",
            "label": "天逸-电商宝(美元)",
            "ownership_type": "cooperate",
            "disabled": null
          },
          {
            "value": "14",
            "label": "天逸-电商宝(人民币)",
            "ownership_type": "cooperate",
            "disabled": null
          },
          {
            "value": "11",
            "label": "蚂蚁金服-ALG美金贷",
            "ownership_type": "cooperate",
            "disabled": null
          },
          {
            "value": "21",
            "label": "陆安-自营美元贷",
            "ownership_type": "cooperate",
            "disabled": null
          }
        ]
      }
    ],
    // AI 动画全局状态
    aiAnimation: {
      show: false,
      apiCompleted: false,
      reportId: null,
      detailDataLoaded: false, // 详情页数据是否加载完成
      startStepIndex: 0 // 从第几步开始（0 = 第 1 步，8 = 第 9 步）
    }
  },
  getters: {
    token: state => state.user.token,
    menus: state => state.user.menus,
    roles: state => state.user.roles,
    index_page: state => state.user.index_page,
    loanOptions: state => state.loanOptions,
    loanOptionsGroup: state => state.loanOptionsGroup
  },
  mutations: {
    SET_USER: (state, user) => {
      // 登录身份变化时，不能沿用上一账号的人员范围或请求状态。
      if (state.user.token !== user.token) {
        state.bdOptions = []
        state.allBdOptions = []
        state.bdOptionsLoading = false
        state.bdOptionsLoaded = false
      }
      const key = process.env.VUE_APP_COOKIE_KEY
      if (user.token) {
        storage.set(key, user)
        sessionStorage.set('permissions', user.permissions)
      } else {
        storage.remove(key)
        sessionStorage.remove('permissions')
      }
      state.user = user
    },
    changeModal (state: any, params) {
      state[params] = !state[params]
    },
    setLoading (state, active) {
      state.loading = active
    },
    setLoanOptions (state, active) {
      state.loanOptions = active
      const selfArray = active.filter(item => item.ownership_type === 'self')
      const cooperateArray = active.filter(item => item.ownership_type === 'cooperate')
      // const selfAll = selfArray.map(item => {
      //   return item.value
      // })
      // console.log(selfAll)
      state.loanOptionsGroup = [
        {
          label: '自营产品',
          value: 'self',
          children: selfArray
        },
        {
          label: '合作产品',
          value: 'cooperate',
          children: cooperateArray
        }
      ]
    },
    setBdOptions (state, active) {
      state.bdOptions = active.map(item => {
        return {
          label: item.nickname,
          value: item.id,
          dept_name: item.dept_name
        }
      })
    },
    setAllBdOptions (state, active) {
      state.allBdOptions = active.map(item => {
        return {
          label: item.nickname,
          value: item.id,
          dept_name: item.dept_name
        }
      })
      state.bdOptionsLoaded = true
    },
    setBdOptionsLoading (state, loading) {
      state.bdOptionsLoading = loading
    },
    setRegionOptions (state, active) {
      state.regionOptions['NA'] = active.filter(item => item.region_code === 'NA')
      state.regionOptions['EU'] = active.filter(item => item.region_code === 'EU')
      state.regionOptions['ES'] = active.filter(item => item.region_code === 'ES')
    },
    // AI 动画状态管理
    SET_AI_ANIMATION_SHOW (state, show) {
      state.aiAnimation.show = show
    },
    SET_AI_ANIMATION_API_COMPLETED (state, completed) {
      state.aiAnimation.apiCompleted = completed
    },
    SET_AI_ANIMATION_REPORT_ID (state, reportId) {
      state.aiAnimation.reportId = reportId
    },
    SET_AI_ANIMATION_DETAIL_DATA_LOADED (state, loaded) {
      state.aiAnimation.detailDataLoaded = loaded
    },
    SET_AI_ANIMATION_START_STEP (state, stepIndex) {
      state.aiAnimation.startStepIndex = stepIndex
    },
    RESET_AI_ANIMATION (state) {
      state.aiAnimation.show = false
      state.aiAnimation.apiCompleted = false
      state.aiAnimation.reportId = null
      state.aiAnimation.detailDataLoaded = false
      state.aiAnimation.startStepIndex = 0
    }
  },
  actions: {
    /**
     * 加载共用人员列表，成功后复用；失败时允许下次打开下拉重试。
     */
    async loadBdOptions ({ state, commit }) {
      const token = state.user.token
      if (!token || state.bdOptionsLoaded || state.bdOptionsLoading) return
      commit('setBdOptionsLoading', true)
      try {
        const res = await userList({ page_size: '200', status: 'Normal' })
        if (state.user.token !== token) return
        const DEFAULT_DEPT_NAMES = ['市场中心', 'KA营销中心', '生态流量部', '市场一部', '市场一部二队', '市场二部', '市场三部']
        const deptFiltered = isPermission('hide:internal:fields')
          ? res.data
          : res.data.filter(item => DEFAULT_DEPT_NAMES.includes(item.dept_name))
        commit('setBdOptions', deptFiltered)
        commit('setAllBdOptions', res.data)
        return true
      } catch {
        if (state.user.token === token) {
          message.warning('人员列表加载失败，请重新打开下拉框重试')
        }
        return false
      } finally {
        if (state.user.token === token) commit('setBdOptionsLoading', false)
      }
    },
    // 登录
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          if (response.res_code === 200) {
            const result = response.data
            // Vue.ls.set('USER_INFO', result, 7 * 24 * 60 * 60 * 1000)
            commit('SET_USER', result)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Logout ({ commit }) {
      commit('SET_USER', {})
      window.location.reload()
    }
  },
  modules: {
  }
})
